import React, { useEffect, useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import config from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faPlus, faSave, faMinus, faHome, faAngleDoubleLeft, faAngleDoubleRight, faEye, faEyeSlash, faSearch, faSort, faSortUp, faSortDown, faCopy } from '@fortawesome/free-solid-svg-icons';
import PopupService from '../PopupService';
import { useApi } from '../../ApiContext';
import { apiFetch } from '../utils/ApiFetch';
  const DisplayRouting = () => {
    const [clients, setClients] = useState([]);   
    const [loading, setLoading] = useState(true);
    const [selectedClientId, setSelectedClientId] = useState('');
    const username = sessionStorage.getItem("username");
    const mrToken = localStorage.getItem("mr_token");
    const [routingData, setRoutingData] = useState([]);
    const [routingHeaders, setRoutingHeaders] = useState([]);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [gotoPageInput, setGotoPageInput] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
	const { callApi, setIsApiLoading } = useApi();
	const visibleHeaders = routingHeaders.filter(header => header !== 'mongo_id');
	const [editingCell, setEditingCell] = useState(null); // { rowIdx, colIdx }
	const [editingValue, setEditingValue] = useState('');
	const [addingRow, setAddingRow] = useState(false);
	const [newRowData, setNewRowData] = useState({});
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [rowToDelete, setRowToDelete] = useState(null);
	const [showUploadForm, setShowUploadForm] = useState(false);
	const [uploadFile, setUploadFile] = useState(null);
	const [uploadMode, setUploadMode] = useState('add'); // 'add' or 'replace'
	const clientName = clients.find(c => (c.clientId || c.id) === selectedClientId)?.clientName || '';
	const [routingType, setRoutingType] = useState('');
	const [showTestRouting, setShowTestRouting] = useState(false);
	const [testRow, setTestRow] = useState({});
	const [testRoutingRows, setTestRoutingRows] = useState([]);
	const [testRoutingTotal, setTestRoutingTotal] = useState(0);
	const [testRoutingPage, setTestRoutingPage] = useState(1);
	const [testRoutingPageSize, setTestRoutingPageSize] = useState(20);
	const testResultHeaders = ['No', ...visibleHeaders];

	
	useEffect(() => {
      const fetchClients = async () => {
		setLoading(true);
			await callApi(async () => {
				setIsApiLoading(true);
	        try {
	          const response = await apiFetch(`${config.API_BASE_URL}/activeclients`,
	            {headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`}},
	          );
	          if (response.ok) {
	            const data = await response.json();
	            setClients(Array.isArray(data.data.ACTIVE_CLIENTS) ? data.data.ACTIVE_CLIENTS : []);
	          }
	        } catch (err) {
	          setClients([]);
	        }finally {
	  			setLoading(false);
	  			setIsApiLoading(false);
	  		}
		  	});
      };
      fetchClients();
    }, []);
    
    useEffect(() => {
      if (selectedClientId) {
        fetchRoutingData(selectedClientId, searchTerm, (currentPage - 1) * limit, limit);
      }
      // eslint-disable-next-line
    }, [searchTerm, selectedClientId, currentPage, limit]);
	

	// Add this handler in your component

	const handleValidateRoutingFile = async () => {
	  if (!uploadFile || !selectedClientId) {
	    PopupService.getInstance().showMessage('Please select a file and client.', false);
	    return;
	  }
	  const formData = new FormData();
	  formData.append('file', uploadFile);
	  formData.append('clientId', selectedClientId);

	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/validateRoutingFile`, {
	        method: 'POST',
	        headers: { 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	        body: formData
	      });
	      const data = await response.json();
	      const validationResult = data.VALIDATION_RESULT;
	      const fileBase64 = data.VALIDATED_FILE;

	      if (validationResult === 'Valid File') {
	        PopupService.getInstance().showMessage('The upload file is a valid file.', true);
	      } else {
	        PopupService.getInstance().showMessage('The upload file is not valid.', false);
	      }

	      if (fileBase64) {
	        const byteCharacters = atob(fileBase64);
	        const byteNumbers = new Array(byteCharacters.length);
	        for (let i = 0; i < byteCharacters.length; i++) {
	          byteNumbers[i] = byteCharacters.charCodeAt(i);
	        }
	        const byteArray = new Uint8Array(byteNumbers);
	        const blob = new Blob([byteArray], { type: 'text/plain' });
	        const url = window.URL.createObjectURL(blob);
	        const a = document.createElement('a');
	        a.href = url;
	        a.download = 'validated_routing_file.txt';
	        document.body.appendChild(a);
	        a.click();
	        a.remove();
	        window.URL.revokeObjectURL(url);
	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};

    
    // Fetch routing headers for selected client
    const fetchRoutingHeaders = async (clientId) => {
      const response = await apiFetch(
        `${config.API_BASE_URL}/routingColumns`,
        { headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` } ,
        method: 'POST',  
        body: JSON.stringify({ clientId})
        }
    );
      if (response.ok) {
        const data = await response.json();
        setRoutingHeaders(data.data.ROUTING_HEADERS || []);
      }
    };
    
    // Pagination group logic: only 10 page numbers at a time
    const pageGroupSize = 10;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }
    const handleGotoPage = () => {
      const page = Number(gotoPageInput);
      if (!page || page < 1 || page > totalPages) {
        PopupService.getInstance().showMessage('Entered page number not valid', false);
        return;
      }
      setCurrentPage(page);
    };
    
    const fetchRoutingData = async (clientId, search = '', offset = 0, limit = 10) => {
		setLoading(true);
		await callApi(async () => {
		setIsApiLoading(true);
			try {
		        const response = await apiFetch(
		          `${config.API_BASE_URL}/displayRoutings`,
		          {
		            method: 'POST',
		            headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
		            body: JSON.stringify({ clientId, search, offset, limit: limit })
		          }
		        );
		        if (response.ok) {
		          const data = await response.json();
		          setRoutingData(data.data.SEARCH_LIST || []);
		          const totalCount = data.data.total;
		          setTotalCount(totalCount || 0);
		          setTotalPages(Math.ceil(totalCount / limit) || 1);
		        }else{
				  PopupService.getInstance().showMessage("Error in displaying routing!", false);
				}
	       }catch (err) {	
			 PopupService.getInstance().showMessage("Error in displaying routing!", false);
		   }finally {
	  		 setLoading(false);
	  		 setIsApiLoading(false);
	  	   }
	  	});		
      };
      
    
	  const handleClientChange = async (e) => {
		const clientId = e.target.value;
		 setSelectedClientId(clientId);
		 setTestRoutingRows([]); // Reset test routing rows
		 setTestRoutingTotal(0);
		 setTestRoutingPage(1);
		 setTestRow({});
		 setRoutingType(''); 

	    if (clientId) {
	      await fetchRoutingHeaders(clientId);
	      await fetchRoutingData(clientId, '', 0, limit);
	      const client = clients.find(c => (c.clientId || c.id) === clientId);
	      setRoutingType(client?.routingType || '');
	      setShowTestRouting(false);
	      setTestRow({});
	    } else {
	      setRoutingHeaders([]);
	      setRoutingData([]);
	      setTotalCount(0);
	      setRoutingType('');
	      setShowTestRouting(false);
	      setTestRow({});
	    }
	  };
      
	  const handleRefresh = async () => {
	    setCurrentPage(1);
	    setSearchTerm('');
	    setGotoPageInput('');
	    setSearchInput(''); // Clear the search input box
	    await fetchRoutingData(selectedClientId, '', 0, limit);
	  };


	// Handle cell click
	const handleCellClick = (rowIdx, colIdx, value) => {
	  setEditingCell({ rowIdx, colIdx });
	  setEditingValue(value);
	};

	// Handle input change
	const handleInputChange = (e) => setEditingValue(e.target.value);

	// Handle save on Enter
	// Add this handler
	const handleSaveCell = async (row, header) => {
		setLoading(true);
		await callApi(async () => {
		setIsApiLoading(true);
		try {
		 const response =  await apiFetch(`${config.API_BASE_URL}/saveRouting`, {
		    method: 'POST',
		    headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
		    body: JSON.stringify({
		      clientId: selectedClientId,
		      mongo_id: row.mongo_id,
		      columnName: header,
		      columnData: editingValue
		    })
		  });
		  const result = await response.json();
		  if (response.ok) {
			
			PopupService.getInstance().showMessage('Routing saved successfully', true);
			setRoutingData(prev => {
			    const updated = [...prev];
			    updated[editingCell.rowIdx][header] = editingValue;
				return updated;
			});
		  }	else{
			PopupService.getInstance().showMessage(result.message, false);
		  }	    
	  	  setEditingCell(null);
	    }catch (error){
		   PopupService.getInstance().showMessage('The routing could not be saved', false);
  	    } finally {
  	      setLoading(false);
  	      setIsApiLoading(false);
  	    }
	  });
	};

	// Update handleInputKeyDown
	const handleInputKeyDown = async (e, row, header) => {
	  if (e.key === 'Enter') {
	    await handleSaveCell(row, header);
	  } else if (e.key === 'Escape') {
	    setEditingCell(null);
	  }
	};
		
	// Handler to start adding
	const handleAddRow = () => {
	  const emptyRow = {};
	  visibleHeaders.forEach(header => { emptyRow[header] = ''; });
	  setNewRowData(emptyRow);
	  setAddingRow(true);
	};

	// Handler for input change in new row
	const handleNewRowChange = (header, value) => {
	  setNewRowData(prev => ({ ...prev, [header]: value }));
	};

	// Handler to save new row

	const handleSaveNewRow = async () => {
	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/addRouting`, {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	        body: JSON.stringify({
	          clientId: selectedClientId,
	          rowData: newRowData
	        })
	      });
	      const data = await response.json();
	      if (response.ok) {
	        PopupService.getInstance().showMessage('New routing row added', true);
	        setAddingRow(false);
	        setNewRowData({});
	        await fetchRoutingData(selectedClientId, searchTerm, (currentPage - 1) * limit, limit);
	      } else {

			if (data.message && data.message.includes('not found in the tracking system')) {
			  const confirmed = await PopupService.getInstance().showConfirm(
			    `${data.message}\nDo you want to create the new Domain/Subdomain?`
			  );
			  if (confirmed) {
			    const createResponse = await apiFetch(`${config.API_BASE_URL}/createDSNSaveRouting`, {
			      method: 'POST',
			      headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
			      body: JSON.stringify({
			        clientId: selectedClientId,
			        rowData: newRowData
			      })
			    });
			    const createData = await createResponse.json();
			    if (createResponse.ok) {
			      PopupService.getInstance().showMessage('Domain/Subdomain created and routing row added', true);
			      setAddingRow(false);
			      setNewRowData({});
			      await fetchRoutingData(selectedClientId, searchTerm, (currentPage - 1) * limit, limit);
			    } else {
			      PopupService.getInstance().showMessage(createData.message || 'Failed to create Domain/Subdomain', false);
			    }
			  }
			} else {
			  PopupService.getInstance().showMessage(data.message, false);
			}

	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};

		
	const handleCancelAddRow = () => {
	  setAddingRow(false);
	  setNewRowData({});
	};
		
	// Handler to open modal
	const handleDeleteClick = (row) => {
	  setRowToDelete(row);
	  setShowDeleteModal(true);
	};

	// Handler to confirm delete
	const handleConfirmDelete = async () => {
	  setShowDeleteModal(false);
	  if (!rowToDelete) return;
	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/deleteRouting`, {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	        body: JSON.stringify({
	          clientId: selectedClientId,
	          mongo_id: rowToDelete.mongo_id
	        })
	      });
	      if (response.ok) {
	        PopupService.getInstance().showMessage('Routing deleted successfully', true);
	        await fetchRoutingData(selectedClientId, searchTerm, (currentPage - 1) * limit, limit);
	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	      setRowToDelete(null);
	    }
	  });
	};

	// Handler to cancel modal
	const handleCancelDelete = () => {
	  setShowDeleteModal(false);
	  setRowToDelete(null);
	};

	const handleShowUploadForm = () => {
	  setShowUploadForm(true);
	  setUploadFile(null);
	  setUploadMode('add');
	  setTimeout(() => {
	    const el = document.getElementById('routing_file_upload');
	    if (el) {
	      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
	    }
	  }, 100); // Wait for form to render
	};


	// Handler for file input
	const handleFileChange = (e) => setUploadFile(e.target.files[0]);

	// Handler for radio change
	const handleUploadModeChange = (e) => setUploadMode(e.target.value);

	// Handler for form submit
	const handleUploadSubmit = async (e) => {
	  e.preventDefault();
	  if (!uploadFile || !selectedClientId) {
	    PopupService.getInstance().showMessage('Please select a file and client.', false);
	    return;
	  }
	  const formData = new FormData();
	  formData.append('file', uploadFile);
	  formData.append('clientId', selectedClientId);
	  formData.append('mode', uploadMode);

	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/addOrReplaceRouting`, {
	        method: 'POST',
	        headers: { 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	        body: formData
	      });
	      const data = await response.json();
	      if (response.ok) {
	        PopupService.getInstance().showMessage('Routing file processed successfully', true);
	        setShowUploadForm(false);
	        await fetchRoutingData(selectedClientId, searchTerm, (currentPage - 1) * limit, limit);
	      } else {
	        PopupService.getInstance().showMessage(data.message || 'Failed to process routing file', false);
	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};

	const handleCancelUploadForm = () => {
	  setShowUploadForm(false);
	  setUploadFile(null);
	  setUploadMode('add');
	};


	// Add this handler in your component

	const handleDownloadRouting = async () => {
	  if (!selectedClientId) {
	    PopupService.getInstance().showMessage('Please select a client.', false);
	    return;
	  }
	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/downloadRoutingForClient`, {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	        body: JSON.stringify({ clientId: selectedClientId })
	      });
	      if (response.ok) {
	        // Generate filename at frontend
	        const randomNum = Math.floor(100000 + Math.random() * 900000); // 6-digit random
	        const filename = `routing_logic_${selectedClientId}_${randomNum}.txt`;

	        const blob = await response.blob();
	        const url = window.URL.createObjectURL(blob);
	        const a = document.createElement('a');
	        a.href = url;
	        a.download = filename;
	        document.body.appendChild(a);
	        a.click();
	        a.remove();
	        window.URL.revokeObjectURL(url);
	        PopupService.getInstance().showMessage('Routing file downloaded.', true);
	      } else {
	        PopupService.getInstance().showMessage('Failed to download routing file.', false);
	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};
	const handleTestRowChange = (header, value) => {
	  setTestRow(prev => ({ ...prev, [header]: value }));
	};


	// JavaScript
	const handleTestRouting = async (page = 1, pageSize = 20) => {
	  if (!selectedClientId) return;
	  setLoading(true);
	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      // Fetch routing headers
	      

	      // Fetch test routing data
	      const payload = {
	        clientId: selectedClientId,
	        pageno: Number.isFinite(page) && page > 0 ? page : 1,
	        pagesize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 20,
	        ...testRow
	      };
	      Object.keys(payload).forEach(key => {
	        if (typeof payload[key] === 'object' && payload[key] !== null) {
	          delete payload[key];
	        }
	      });
	      const response = await apiFetch(`${config.API_BASE_URL}/testWcRouting`, {
	        method: 'POST',
		    headers: {
			            'Content-Type': 'application/json',
			            'X-Username': username,
			            'Authorization': `Bearer ${mrToken}`
			          },
	        body: JSON.stringify(payload)
	      });
	      const data = await response.json();
	      setTestRoutingRows(data.data.WC_TEST_LIST || []);
	      setTestRoutingTotal(data.data.total || 0);
	      setTestRoutingPage(payload.pageno);
	      setTestRoutingPageSize(payload.pagesize);
	      // Set headers for rendering
	      setRoutingHeaders(routingHeaders);
	      //PopupService.getInstance().showMessage('Test Routing completed.', true);
	    } catch(error){
			PopupService.getInstance().showMessage('Error in testing wild card. Try again', false);
		}
			finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};



	// Pagination controls for test routing
	const testRoutingTotalPages = Math.ceil(testRoutingTotal / testRoutingPageSize);

	const handleTestRoutingPageChange = (newPage) => {
	  if (newPage < 1 || newPage > testRoutingTotalPages) return;
	  handleTestRouting(newPage, testRoutingPageSize);
	};

	// Handle Cancel button
	const handleCancelTestRouting = () => {
	  //setShowTestRouting(false);
	  setRoutingType('old');
	  setTestRow({});
	};
	const TestRoutingPagination = ({
	  currentPage,
	  totalPages,
	  onPageChange
	}) => {
	  const [jumpPage, setJumpPage] = useState('');

	  // Calculate page numbers to display
	  let start = Math.max(1, currentPage - 3);
	  let end = Math.min(totalPages, currentPage + 3);
	  if (end - start < 6) {
	    if (start === 1) end = Math.min(totalPages, start + 6);
	    else if (end === totalPages) start = Math.max(1, end - 6);
	  }
	  const pageNumbers = [];
	  for (let i = start; i <= end; i++) pageNumbers.push(i);

	  const handleJump = () => {
	    const page = Number(jumpPage);
	    if (page >= 1 && page <= totalPages) {
	      onPageChange(page);
	      setJumpPage('');
	    }
	  };

	  return (
	    <div className="d-flex align-items-center my-2">
	      <button
	        className="btn btn-sm btn-outline-secondary me-2"
	        disabled={currentPage === 1}
	        onClick={() => onPageChange(currentPage - 1)}
	      >
	        Prev
	      </button>
	      {pageNumbers.map(num => (
	        <button
	          key={num}
	          className={`btn btn-sm mx-1 ${num === currentPage ? 'btn-primary' : 'btn-outline-secondary'}`}
	          onClick={() => onPageChange(num)}
	        >
	          {num}
	        </button>
	      ))}
	      <button
	        className="btn btn-sm btn-outline-secondary ms-2"
	        disabled={currentPage === totalPages}
	        onClick={() => onPageChange(currentPage + 1)}
	      >
	        Next
	      </button>
	      <span className="ms-3">Jump to:</span>
	      <input
	        type="number"
	        min="1"
	        max={totalPages}
	        value={jumpPage}
	        onChange={e => setJumpPage(e.target.value)}
	        className="form-control form-control-sm mx-2"
	        style={{ width: '70px' }}
	        onKeyDown={e => { if (e.key === 'Enter') handleJump(); }}
	      />
	      <button
	        className="btn btn-sm btn-success"
	        onClick={handleJump}
	        disabled={!jumpPage || Number(jumpPage) < 1 || Number(jumpPage) > totalPages}
	      >
	        Go
	      </button>
	      <span className="ms-3 text-muted">Page {currentPage} of {totalPages}</span>
	    </div>
	  );
	};
return (
    <>
        <Header />
		<div className="container-fluid text-secondary">
		<br />
        <br />
        <br />
        <div className='card'>
		<div className='card-header'>View Routing For Clients</div>
		<div className='card-body custom-card-bg'>
          <div className='card'>
          <div className="card-body">
		      <div className='row'>
			  <div className="form-group col-md-2">
	  	          <label htmlFor="client_select" className="text-info fw-bold">Select Client</label>
	  	                                              
	  		        <select
	  		          id="client_select"
	  		          className="form-select"
	  		          value={selectedClientId}
	  		          onChange={handleClientChange}
	  		        >
	  		         <option value="">Select Client</option>
	  		          {clients.map((client, idx) => (
	  		            <option key={idx} value={client.clientId || client.id}>
	  		              {client.clientName || client.name}
	  		            </option>
	  		          ))}
	  		       </select> 
			  </div>
			  <div className="form-group col-md-2">
			  <br/>
			  <button
  			      type="button"
  			      className="btn btn-sm btn-success"
  			      onClick={handleDownloadRouting}
  			      disabled={!selectedClientId}
  			    >
  			      Download Routing
  			    </button>
			  </div>
	    	</div>
			{/* start test routing */}
			<br/>
			
			    
				{routingType === 'wc' && (
				  <>
				  <div  className='card'>
				  <div className='card-header'>Test Wildcard Routing - {selectedClientId} -  {clientName}</div>
				   <div className='card-body'>				    
				      <div className="card mt-3">
				        <table className="table">
				          <thead>
				            <tr>
				              {visibleHeaders.map(col => <th key={col}>{col}</th>)}
				              <th>Actions</th>
				            </tr>
				          </thead>
				          <tbody>
				            <tr>
				              {visibleHeaders.map(col => (
				                <td key={col}>
				                  <input
				                    type="text"
				                    value={testRow[col] || ''}
				                    onChange={e => handleTestRowChange(col, e.target.value)}
				                  />
				                </td>
				              ))}
				              <td>
				                <button className="btn btn-warning btn-sm" onClick={handleTestRouting}>Test Wildcard Routing</button>
				                &nbsp;
				                <button className="btn btn-secondary btn-sm" onClick={handleCancelTestRouting}>Cancel</button>
				              </td>
				            </tr>
							
				          </tbody>
				        </table>
						<br/>
						<br/>
						{/*start test */}
						{testRoutingRows.length > 0 && (											
						    <div>							
							<table className="table table-bordered table-striped" id="test_result_table">
							  <thead>
							    <tr>
							      {testResultHeaders.map(header => (
							        <th key={header}>{header}</th>
							      ))}
							    </tr>
							  </thead>
							  <tbody>
							    {testRoutingRows.map((row, rowIdx) => (
							      <tr key={rowIdx}>
							        {testResultHeaders.map(header => {
							          if (header === 'No') {
							            return <td key="No">{(testRoutingPage - 1) * testRoutingPageSize + rowIdx + 1}</td>;
							          }
							          const value = row[header];
							          return (
							            <td key={header}>
							              {typeof value === 'object' && value !== null ? JSON.stringify(value) : value ?? ''}
							            </td>
							          );
							        })}
							      </tr>
							    ))}
							  </tbody>
							</table>

						      {testRoutingTotal > testRoutingPageSize && (
								
								<TestRoutingPagination
								  currentPage={testRoutingPage}
								  totalPages={testRoutingTotalPages}
								  onPageChange={handleTestRoutingPageChange}
								/>
						      )}
						    </div>
						  )
						}
						{/*en d test */}
				      </div>
					</div>					  				
				</div>	
				
				
			</>
			)}
			{/* start test routing */}
			
			
			<div id="routing_file_upload">
			{showUploadForm && (
				<>
			  <div  className='card'>
			    <div className='card-header'>Upload Routing File - {selectedClientId} -  {clientName}</div>
			    <div className='card-body'>
			      <form onSubmit={handleUploadSubmit} encType="multipart/form-data">
			        <div className='row'>
			          <div className="form-group col-md-5">
			            <input type="file" className="form-control" accept=".txt" onChange={handleFileChange} required />
			          </div>
			          <div className="form-group col-md-4">
			            <label>
			              <input
			                type="radio"
			                name="uploadMode"
			                value="add"
			                checked={uploadMode === 'add'}
			                onChange={handleUploadModeChange}
			              /> Add to Existing Routing
			            </label>
			            <label style={{ marginLeft: '20px' }}>
			              <input
			                type="radio"
			                name="uploadMode"
			                value="replace"
			                checked={uploadMode === 'replace'}
			                onChange={handleUploadModeChange}
			              /> Replace existing routing
			            </label>
			          </div>
			          <div className="form-group col-md-3">

					  <button
					    type="button"
					    className="btn btn-sm btn-info mt-2"
					    onClick={handleValidateRoutingFile}
					    disabled={!uploadFile}
					  >
					    Validate Routing File
					  </button>
                      &nbsp;
			            <button type="submit" className="btn btn-sm btn-danger mt-2">Upload Routing File</button>
						&nbsp;&nbsp;
						   {showUploadForm && (
						     <button
						       className="btn btn-sm btn-secondary mt-2"
						       onClick={handleCancelUploadForm}
						     >
						       Cancel 
						     </button>
						   )}
						 </div>
			        </div>
			      </form>
			    </div>
			  </div>
			  <br/>
			  </>
			)}

			</div>
			
			
			<div className='card' id="routing_loader">
			 <div className='card-header'>Routing Data - {selectedClientId} -  {clientName}</div>
			 <div className='card-body'>
			 <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
			 
				
				<div className="d-flex">
				<label className="mr-6 mb-0">Rows per page:</label>
				<select
					value={limit}
					onChange={e => { setLimit(Number(e.target.value)); setCurrentPage(1); }}
					className="form-control d-inline-block mr-3 text-secondary"
					style={{ width: 'auto', display: 'inline-block' }}
				>
					<option value={20}>20</option>
					<option value={40}>40</option>
					<option value={60}>60</option>
				</select>
				&nbsp;
				
                <div className="float-right search btn-group ">
                <input
                  className="form-control search-input"
                  placeholder="Search Configured matches"
                  value={searchInput}
                  onChange={e => setSearchInput(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      setSearchTerm(searchInput);
                      setCurrentPage(1);
                    }
                  }}
                />&nbsp;
					<button
	                  className="btn btn-secondary"
	                  type="button"
	                  name="search"
	                  aria-label="Search"
	                  title="Search"
	                  onClick={() => {
	                    setSearchTerm(searchInput);
	                    setCurrentPage(1);
	                  }}
	                >
					<FontAwesomeIcon icon={faSearch} />
                    </button>
	                &nbsp;
	                <div className="input-group-prepend">
	                    <button className="btn btn-secondary" type="button" name="refresh" aria-label="Refresh" title="Refresh"
	                            onClick={handleRefresh}
	                    >
	                        <FontAwesomeIcon icon={faSyncAlt} />
	                    </button>
	                </div>
				</div>
				</div>
				</div>
				
				<table className="table table-bordered table-striped">
				<thead>
				  <tr>
				    <th></th> {/* For delete button */}
				    <th>No.</th>
				    {visibleHeaders.map((header, idx) => (
				      <th key={idx}>{header}</th>
				    ))}
				  </tr>
				</thead>
				<tbody>
				  {routingData.length === 0 ? (
				    <tr>
				      <td colSpan={visibleHeaders.length + 2} className="text-center text-nowrap">No data</td>
				    </tr>
				  ) : (
				    routingData.map((row, rowIdx) => (
				      <tr  key={rowIdx}>
				        <td>
				          <button
				            className="btn btn-link p-0"
				            onClick={() => handleDeleteClick(row)}
				            aria-label="Delete"
				            title="Delete"
				          >
				            <i className="fa fa-trash text-danger"></i>
				          </button>
				        </td>
				          <td>{(currentPage - 1) * limit + rowIdx + 1}</td>
				          {visibleHeaders.map((header, colIdx) => (
							<td 
							  key={colIdx}
							  onClick={() => handleCellClick(rowIdx, colIdx, row[header])}
							  style={{ cursor: 'pointer' }}
							>
							  {editingCell && editingCell.rowIdx === rowIdx && editingCell.colIdx === colIdx ? (
							    <div style={{ display: 'flex', alignItems: 'center' }}>
							      <input
							        type="text"
							        value={editingValue}
							        autoFocus
							        onChange={handleInputChange}
							        onKeyDown={e => handleInputKeyDown(e, row, header)}
							        onBlur={() => setEditingCell(null)}
							        style={{ width: '100%' }}
							      />

								  <button
								    type="button"
								    className="btn btn-link p-0 ms-2"
								    onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
								    onClick={() => handleSaveCell(row, header)}
								    aria-label="Save"
								    title="Save"
								  >
								    <i className="fa fa-save text-danger"></i>
								  </button>

							    </div>
							  ) : (
							    row[header]
							  )}
							</td>
				          ))}
				        </tr>
				      ))
				    )}
					{addingRow && (
					  <tr>
					    <td>New</td><td>&nbsp;</td>
					    {visibleHeaders.map((header, idx) => (
					      <td key={idx}>
					        <input
					          type="text"
					          value={newRowData[header] || ''}
					          onChange={e => handleNewRowChange(header, e.target.value)}
					          style={{ width: '100%' }}
					        />
					      </td>
					    ))}
					    <td>
					      <button
					        className="btn btn-link p-0 ms-2"
					        onClick={handleSaveNewRow}
					        aria-label="Save"
					        title="Save"
					      >
					        <i className="fa fa-save text-success"></i>
					      </button>
					    </td>
					  </tr>
					)}

					
					
				  </tbody>
				  {showDeleteModal && (
				    <div className="modal show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
				      <div className="modal-dialog">
				        <div className="modal-content">
				          <div className="modal-header">
				            <h5 className="modal-title">Confirm Delete</h5>
				            <button type="button" className="btn-close" onClick={handleCancelDelete}></button>
				          </div>
				          <div className="modal-body">
				            <p>Do you really want to delete this record?</p>
				          </div>
				          <div className="modal-footer">
				            <button className="btn btn-danger" onClick={handleConfirmDelete}>Yes</button>
				            <button className="btn btn-secondary" onClick={handleCancelDelete}>No</button>
				          </div>
				        </div>
				      </div>
				    </div>
				  )}
	           </table>

			   {selectedClientId && (
			     <>
			       <button
			         className="btn btn-sm btn-danger mt-2"
			         onClick={handleAddRow}
			         disabled={addingRow}
			       >
			         Add Routing
			       </button>
			       &nbsp;&nbsp;
			       <button
			         className="btn btn-sm btn-primary mt-2"
			         onClick={handleShowUploadForm}
			         disabled={addingRow}
			       >
			         Upload Routing File
			       </button>
			     </>
			   )}
			   &nbsp;
			   {addingRow && (
				 
			     <button
			       className="btn btn-sm btn-secondary mt-2"
			       onClick={handleCancelAddRow}
			     >
			       Cancel Add Routing
			     </button>
			   )}

			   {/* Pagination controls */}
 				<div className="d-flex justify-content-between align-items-center mt-3">
                   <span className="text-secondary">Page {currentPage} of Total Pages: {totalPages} - {totalCount} Records</span>
                   <nav>
                       <ul className="pagination mb-0">
                           <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                               <button className="page-link text-secondary" onClick={() => {setCurrentPage(1);setGotoPageInput(''); }} disabled={currentPage === 1}>
                                   <FontAwesomeIcon icon={faAngleDoubleLeft} />
                               </button>
                           </li>
                           <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                               <button className="page-link text-secondary" onClick={() => {setCurrentPage(currentPage - 1);setGotoPageInput(''); }} disabled={currentPage === 1}>
                                   Previous
                               </button>
                           </li>
                           {pageNumbers.map((page) => (
                               <li key={page} className={`page-item${currentPage === page ? ' active' : ''}`}>
                                   <button
                                       className={`page-link ${currentPage === page ? 'text-light' : 'text-secondary'}`}
                                       onClick={() => {setCurrentPage(page);setGotoPageInput(''); }}
                                   >
                                       {page}
                                   </button>
                               </li>
                           ))}
                           <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
                               <button className="page-link text-secondary" onClick={() => {setCurrentPage(currentPage + 1);setGotoPageInput(''); }} disabled={currentPage === totalPages}>
                                   Next
                               </button>
                           </li>
                           <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
                               <button className="page-link text-secondary" onClick={() => {setCurrentPage(totalPages);setGotoPageInput(''); }} disabled={currentPage === totalPages}>
                                   <FontAwesomeIcon icon={faAngleDoubleRight} />
                               </button>
                           </li>
                           <li>
                               <div className="d-flex align-items-center">
                                 <input
                                   type="number"
                                   min="1"
                                   max={totalPages}
                                   value={gotoPageInput}
                                   onChange={e => setGotoPageInput(e.target.value)}
                                   onKeyDown={e => {
                                       if (e.key === 'Enter') {
                                         handleGotoPage();
                                       }
                                     }}
                                   className="form-control"
                                   style={{ width: 100, marginRight: 4 }}
                                   placeholder="Page #"
                                   aria-label="Go to page"
                                 />
                                 <button
                                   className="btn btn-secondary btn-sm"
                                   onClick={handleGotoPage}
                                   type="button"
                                   style={{ marginRight: 8 }}
                                 >
                                   Go
                                 </button>
                               </div>
                           </li>                                                   
                       </ul>
                   </nav>
                 </div>
				 </div>
			   {/* End of Pagination controls */}
			</div>
		  </div>
		  </div>
		</div>
		</div>
		</div>
		<Footer />
    </>
  );
};

export default DisplayRouting;